export default __webpack_public_path__ + "static/media/025-rings.863ee96e.svg";